import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnChange(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let bulk_task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  return function onChange(_, date) {
    submit({
      type: 'set_bulk_tasks_due_date',
      task_and_due_dates: bulk_task_ids.map(task => ({
        id: task,
        due_date: date,
      })),
    })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
